import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { orderInitialState, Customer, ViewOrder } from '../../models/OrderState'
import ordersService from 'app/services/OrdersService/OrdersService'
import * as model from './helper'
import { RootState } from 'setup'
import { getAppProfile } from 'app/utilities'

export const fetchOrder = createAsyncThunk(
  'order/fetch',
  async (id: string, { dispatch, getState }) => {
    const { auth }: any = getState()
    let { paymentProviderType } = auth.user.store
    try {
      dispatch(setIsFetching(true))
      const data = await ordersService.fetchOrder(id)
      if (!paymentProviderType) {
        const appProfile = getAppProfile()
        paymentProviderType = appProfile?.paymentProviderType
      }
      return model.mapToViewOrderModel({ ...data, paymentProviderType })
    } catch (error) {
      console.error(error)
    } finally {
      dispatch(setIsFetching(false))
    }
  }
)

const orderAdapter = createEntityAdapter({ selectId: (order: any) => order.variantId })
export const { selectAll: selectOrderItems } = orderAdapter.getSelectors(
  ({ orders }: any) => orders.orderView
)

const orderSlice = createSlice({
  name: 'order',
  initialState: orderAdapter.getInitialState({ ...orderInitialState }),
  reducers: {
    setViewOrder: (state, action) => {
      state.viewOrder = action.payload
    },
    setIsFetching: (state, action) => {
      state.isFetching = action.payload
    },
    setOrderNotes: (state, action) => {
      state.viewOrder.notes = action.payload
    },
    resetOrderState: () => orderAdapter.getInitialState(orderInitialState),
    setOrderSubtype: (state, action) => {
      state.viewOrder.orderSubtype = action.payload
    },

  },
  extraReducers: {
    [fetchOrder.fulfilled.toString()]: (state, action) => {
      state.viewOrder = action.payload
    },
  },
})

export const { setViewOrder, setIsFetching, resetOrderState, setOrderNotes, setOrderSubtype } = orderSlice.actions

export default orderSlice.reducer

export const selectViewOrder = ({ orders }: RootState): ViewOrder => orders.orderView.viewOrder
export const selectViewOrderDeliveryMethod = ({ orders }: RootState): string | any =>
  orders.orderView.viewOrder.orderDeliveryMethod
export const selectViewOrderFulfillmentStatus = ({ orders }: RootState): string | any =>
  orders.orderView.viewOrder.fulfillmentStatus
export const selectViewOrderCreatedAt = ({ orders }: RootState): string | any =>
  orders.orderView.viewOrder.createdAt
export const selectViewOrderCreatedBy = ({ orders }: RootState): string | any =>
  orders.orderView.viewOrder.createdUser
export const selectViewOrderNumber = ({ orders }: RootState): any =>
  orders.orderView.viewOrder.orderNumber
export const selectViewOrderCustomer = ({ orders }: RootState): Customer =>
  orders.orderView.viewOrder.customer
export const selectOrderCustomerId = ({ orders }: RootState): string =>
  orders.orderView.viewOrder.customerId
export const selectViewOrderNote = ({ orders }: RootState): string => orders.orderView.viewOrder.note
export const selectViewOrderItems = ({ orders }: RootState): any[] =>
  orders.orderView.viewOrder.orderItems
export const selectViewOrderHistory = ({ orders }: RootState): any[] =>
  orders.orderView.viewOrder.orderHistory

export const selectViewOrderNotes = ({ orders }: RootState): any[] => orders.orderView.viewOrder.notes
export const selectOrderIsFetching = ({ orders }: RootState): boolean => orders.orderView.isFetching

export const selectViewMigratedOrderItems = ({ orders }: RootState): any[] =>
  orders.orderView.viewOrder.migratedOrderItems

export const selectOrderTrackings = ({ orders }: RootState): any[] =>
  orders.orderView.viewOrder.orderTrackings

export const selectOrderTransactionPaymentType = ({ orders }: RootState): string =>
  orders.orderView.viewOrder.paymentType

export const selectViewOrderFutureShipDate = ({ orders }: RootState): string | any =>
  orders.orderView.viewOrder.futureShipDate

export const selectViewOrderPaymentStatus = ({ orders }: RootState): string | any =>
  orders.orderView.viewOrder.financialStatus

export const selectViewOrderIsLoginOrder = ({ orders }: RootState): boolean =>
  orders.orderView.viewOrder.isLoginOrder

